export class AreaSettings {
    private static instance: AreaSettings;
    static getInstance() { return AreaSettings.instance || (AreaSettings.instance = new AreaSettings()); }

    areaId: number;

    init(areadId: number): void {
        const instance = AreaSettings.getInstance();
        instance.areaId = areadId;
    }
}